import { httpClient, postProcessUpsert } from "@genai/http-client";

export const fetchFileTypes = async (): Promise<string[]> => {
  return httpClient(`/enums/file-types`).then(postProcessUpsert<string[]>);
};
